var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.31265 11.3127C7.02147 11.3127 5.15631 9.44751 5.15631 7.15633C5.15631 4.86516 7.02147 3 9.31265 3C11.6038 3 13.469 4.86516 13.469 7.15633C13.469 9.44751 11.6038 11.3127 9.31265 11.3127Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5237 21.184H4.10167C2.39237 21.184 1 19.7916 1 18.0824C1 14.9235 3.57173 12.3518 6.73055 12.3518H11.8948C15.0536 12.3518 17.6253 14.9235 17.6253 18.0824C17.6253 19.7916 16.233 21.184 14.5237 21.184Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1941 11.4919C15.6407 11.4919 14.3782 10.2294 14.3782 8.67594C14.3782 7.12251 15.6407 5.85742 17.1941 5.85742C18.7475 5.85742 20.01 7.11991 20.01 8.67334C20.01 10.2268 18.7475 11.4919 17.1941 11.4919Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5504 18.8461H18.8359L18.7761 18.1317C18.7761 18.1213 19.0281 16.7679 18.1449 14.9495C17.2617 13.1311 15.5472 12.3518 15.5472 12.3518H18.9242C21.3167 12.3518 23 14.0065 23 16.399C23 17.7472 21.9012 18.8461 20.5504 18.8461Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.41cf46f95a337ca9d19bfacfda202d45.svg";
export { ForwardRef as ReactComponent };